import React from "react";
import ContentPageTemplate from "../components/ContentPageTemplate";
import { servicePages } from "../data/servicePages";

export default function ServiceDigitaleStrategie() {
  return <ContentPageTemplate {...servicePages.digitaleStrategie} />;
}
